import { useClubData } from '../lib/club-data.context';

/**
 * Hook for managing user profile data
 * Uses the ClubDataContext to access centralized profile data
 */
export function useUserProfile() {
  const { userProfile, isLoading, error, refetchAll, updateProfile } = useClubData();
  
  return { 
    profile: userProfile,
    isLoading,
    error,
    fetchProfile: refetchAll,
    updateProfile
  };
}